const EmployeeHome = () => {
  return <div className="m-4"></div>;
};

export default EmployeeHome;
